import format from "date-fns/format";
import firebase from "firebase/compat/app";

export function dateOrTimestampToString(
  date?: Date | firebase.firestore.Timestamp | unknown,
  formatStyle: string = "d MMM yyyy, h:mm aaa"
) {
  if (!date) {
    return undefined;
  }

  if (date instanceof firebase.firestore.Timestamp) {
    return format(date.toDate(), formatStyle);
  }

  if (date instanceof Date) {
    return format(date, formatStyle);
  }

  return undefined;
}

/**
 * Formats a Firebase timestamp to a date string.
 * Used primarily in chat message info display.
 */
export const formatDate = (
  timestamp: firebase.firestore.Timestamp,
  language: string,
  prefomattedDate = false,
  hideYear = false
) => {
  const date = new Date(timestamp.seconds * 1000);
  const day = date.getDate() < 10 ? "0" + date.getDate() : "" + date.getDate();
  const month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : "" + (date.getMonth() + 1);
  const year = date.getFullYear();
  const hours = date.getHours() < 10 ? "0" + date.getHours() : "" + date.getHours();
  const minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : "" + date.getMinutes();

  if (prefomattedDate) {
    return ` ${hours}:${minutes}`;
  }

  if (hideYear) {
    return `${day}/${month}/${year}`;
  }

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};
